import { initAddressApi } from '../modules/AddressApi.js';

// General code for forms with password fields & enabling submit button when all the required field are filled

jQuery(function($){
    $(`<span class="togglepassword"></span>`).insertAfter($('input[type="password"]'));

    $('.togglepassword').on('click', function(){
        let toggle = $(this);
        if (toggle.hasClass('active')){
            toggle.removeClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'password');
        }
        else{
            toggle.addClass('active');
            $(this).siblings('input[name="password"], input[name="password1"], input[name="password2"], input[name="pwd"]').attr('type', 'text');
        }
    });


    // Voor elke form
    $('form').each(function(){
        // Logica voor formulier validatie
        let form = $(this);    

        function validateForm (){
            if (formRequiredFilled(form)){
                form.find('input[type="submit"]').removeClass('btn--inactive');
            }
            else{
                form.find('input[type="submit"]').addClass('btn--inactive');
            }  
        }

        validateForm();
        form.find('input').on('change', validateForm);

        form.find('input[name="page-title"').val(document.title);

        // Standaard adres automatisch ophalen
        initAddressApi('postcode', 'huisnummer', 'toevoeging',  'adres' , 'stad', form);
    });


    // Check of alle verplichte velden zijn ingevuld
    function formRequiredFilled(form){
        let allFilled = true;
        form.find('input[required], input.required').each(function(){
            let value = $(this).val();
        
            if (value == ''){
                allFilled = false;
            }
        });
        
        return allFilled;
    }


    /* All redirects for all forms */


    document.addEventListener('wpcf7mailsent', function(event) {
        if (event.detail.contactFormId == '1328' || event.detail.contactFormId == '1327') { 
            // Perform the redirection after the form is successfully submitted
            window.location.href = '/bedankt-magazine'; 
        }
        if (event.detail.contactFormId == '7386' || event.detail.contactFormId == '7222') { 
            // Perform the redirection after the form is successfully submitted
            window.location.href = '/bedankt-gratis-advies-afspraak'; 
        }
    }, false);


    $('.wpcf7-form .wpcf7-form-control').on('blur change', function () {
        var $input = $(this);
        var $wrap = $input.closest('.wpcf7-form-control-wrap');
        var value = $input.val();
        var type = $input.attr('type');

        if (type === 'checkbox' || type === 'radio') {
            return;
        }

        // Determine if valid: check browser validity + not empty if required
        var isValid = this.checkValidity() && value.trim() !== '';

        if (isValid) {
        $wrap.addClass('wpcf7-valid').removeClass('wpcf7-invalid');
        } else {
        $wrap.removeClass('wpcf7-valid').addClass('wpcf7-invalid');
        }
    });
});

